import { put, takeEvery } from 'redux-saga/effects';
import AppsAndSolutionsService from '../../services/AppsAndSolutionsService/AppsAndSolutionsService';
import {
  AppsAndSolutionsAction,
  AppsAndSolutionsActionTypes,
  AppsAndSolutionsActions,
} from '../actions/AppsAndSolutionsActions';
import {
  IAvailableApplication,
  ICreateWorkloadPatternPayload,
  ICreateWorkloadPatternResponse,
  IDeployApplicationPayload,
  IEnvironment,
  IEnvironmentPayload,
  IWorkloadPattern,
} from '../../models/AppsAndSolutionsModels';
import { ToastActions } from '../actions/ToastActions';
import { NotificationTypes } from '../../../components/notifications/Toast/ToastConstants';

export function* getEnvironmentWorker(action: AppsAndSolutionsAction) {
  try {
    const response: Array<IEnvironment> = yield AppsAndSolutionsService.getEnvironments(
      action.data as IEnvironmentPayload,
    );
    yield put(AppsAndSolutionsActions.getEnvironmentsSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AppsAndSolutionsActions.getEnvironmentsError(error));
    }
  }
}
export function* getWorkloadPatternsWorker(action: AppsAndSolutionsAction) {
  try {
    const response: Array<IWorkloadPattern> = yield AppsAndSolutionsService.getWorkloadPattern(
      action.data as IEnvironmentPayload,
    );
    yield put(AppsAndSolutionsActions.getWorkloadPatternsSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AppsAndSolutionsActions.getWorkloadPatternsError(error));
    }
  }
}
export function* getAvailableApplicationsWorker(action: AppsAndSolutionsAction) {
  try {
    const response: Array<IAvailableApplication> =
      yield AppsAndSolutionsService.getAvailableApplications(action.data as IEnvironmentPayload);
    yield put(AppsAndSolutionsActions.getAvailableApplicationsSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AppsAndSolutionsActions.getAvailableApplicationsError(error));
    }
  }
}

export function* deployApplicationWorker(action: AppsAndSolutionsAction) {
  try {
    const uploadData = action.data as IDeployApplicationPayload;
    const response: string = yield AppsAndSolutionsService.deployApplication(uploadData);
    yield put(AppsAndSolutionsActions.deployApplicationSuccess(response));
    yield put(
      AppsAndSolutionsActions.getAvailableApplicationsStart({
        account: uploadData.userdata.account,
        project: uploadData.userdata.project,
      }),
    );
    yield put(
      ToastActions.showToast({
        description: `${response} Created`,
        type: NotificationTypes.SUCCESS,
      }),
    );
  } catch (error: any) {
    if (error instanceof Error) {
      if (error.message.includes('503')) {
        yield put(
          ToastActions.showToast({
            description: 'Deploy Application is In Progress. Try refreshing after some time',
            type: NotificationTypes.INFO,
          }),
        );
      } else {
        yield put(
          ToastActions.showToast({
            description: 'Deploy Application Failed',
            type: NotificationTypes.ERROR,
          }),
        );
      }
      yield put(AppsAndSolutionsActions.deployApplicationError(error));
    }
  }
}

export function* createWorkloadPatternWorker(action: AppsAndSolutionsAction) {
  try {
    // API call to deploy Cloud foundation
    const uploadData = action.data as ICreateWorkloadPatternPayload;
    const response: ICreateWorkloadPatternResponse =
      yield AppsAndSolutionsService.createWorkloadPattern(uploadData);
    yield put(AppsAndSolutionsActions.createWorkloadPatternSuccess(response));
    yield put(
      AppsAndSolutionsActions.getWorkloadPatternsStart({
        account: uploadData.userdata.account,
        project: uploadData.userdata.project,
      }),
    );
    yield put(
      ToastActions.showToast({
        description: `${response.WorkloadPatternName} Workload Pattern Created`,
        type: NotificationTypes.SUCCESS,
      }),
    );
  } catch (error) {
    if (error instanceof Error) {
      yield put(AppsAndSolutionsActions.createWorkloadPatternError(error));
      yield put(
        ToastActions.showToast({
          description: `Workload Pattern creation failed`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* hardReloadWorker() {
  yield put(AppsAndSolutionsActions.handleHardReload());
}

export function* appsAndSolutionsWatcher() {
  yield takeEvery(AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_START, getEnvironmentWorker);
  yield takeEvery(
    AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_START,
    getWorkloadPatternsWorker,
  );
  yield takeEvery(
    AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_START,
    getAvailableApplicationsWorker,
  );
  yield takeEvery(AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_START, deployApplicationWorker);
  yield takeEvery(
    AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_START,
    createWorkloadPatternWorker,
  );
  yield takeEvery('persist/REHYDRATE', hardReloadWorker);
}
